import React, { useEffect, useState } from "react";
import api from "../../../api/axios";

export default function PayrollItems() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [usingSample, setUsingSample] = useState(false);

  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);

  const blankForm = {
    name: "",
    code: "",
    type: "earning",
    value_type: "fixed",
    is_taxable: false,
    statutory_code: "",
    amount: 10000,
    is_active: true,
  };

  const [form, setForm] = useState(blankForm);

  const generateCode = (name) => {
    if (!name) return "";
    return name.trim().replace(/\s+/g, "_").toUpperCase();
  };

  useEffect(() => {
    loadItems();
  }, []);

  /* =======================
     LOAD PAYROLL ITEMS
  ========================== */
  const loadItems = async () => {
    setLoading(true);
    try {
      const res = await api.get("hrms/prms/items");
      setItems(res.data.data.data);
      setUsingSample(false);
    } catch (err) {
      console.warn("API failed → using sample items");

      const sample = [
        {
          id: 1,
          name: "Basic",
          code: "BASIC",
          type: "earning",
          value_type: "fixed",
          is_taxable: true,
          statutory_code: "PF/12345",
          amount: 10000,
          is_active: true,
        },
        {
          id: 2,
          name: "HRA",
          code: "HRA",
          type: "earning",
          value_type: "percentage",
          is_taxable: false,
          statutory_code: "",
          amount: 40,
          is_active: true,
        },
        {
          id: 3,
          name: "Professional Tax",
          code: "PT",
          type: "deduction",
          value_type: "fixed",
          is_taxable: false,
          statutory_code: "",
          amount: 200,
          is_active: true,
        },
      ];

      setItems(sample);
      setUsingSample(true);
    }
    setLoading(false);
  };

  /* =======================
      FORM HANDLING
  ========================== */
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const startEdit = (item) => {
    setShowForm(true);
    setEditId(item.id);
    setForm(item);
  };

  const cancelForm = () => {
    setShowForm(false);
    setEditId(null);
    setForm(blankForm);
  };

  /* =======================
      SAVE ITEM (API + SAMPLE)
  ========================== */
  const saveItem = async () => {
    const computedCode = generateCode(form.name);

    const payload = {
      ...form,
      code: computedCode, // <-- FINAL CODE USED IN SAVE
    };
    try {
      if (editId) {
        await api.put(`hrms/prms/items/${editId}`, payload);
        alert("Item Updated");
      } else {
        await api.post("hrms/prms/items", payload);
        alert("Item Added");
      }

      cancelForm();
      loadItems();
    } catch (err) {
      alert("Sample mode save (API not ready)");

      if (editId) {
        setItems((prev) =>
          prev.map((i) => (i.id === editId ? { ...form, id: editId } : i))
        );
      } else {
        setItems((prev) => [...prev, { ...form, id: prev.length + 1 }]);
      }

      cancelForm();
    }
  };

  /* =======================
      UI RENDERING
  ========================== */

  if (loading)
    return (
      <div className="text-center p-5 fw-bold fs-4">
        Loading Payroll Items...
      </div>
    );

  return (
    <div style={{ background: "#eef6fd", minHeight: "100vh" }}>
      <div className="container py-4">
        {/* HEADER */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3 className="fw-bold">Payroll Items</h3>

          <button
            className="btn btn-primary"
            onClick={() => {
              cancelForm();
              setShowForm(true);
            }}
          >
            <i className="bi bi-plus-circle me-2"></i>Add Item
          </button>
        </div>

        {usingSample && (
          <span className="badge bg-warning text-dark mb-3">
            Using Sample Data
          </span>
        )}

        {/* ADD / EDIT FORM */}
        {showForm && (
          <div className="bg-white border rounded shadow-sm p-4 mb-4">
            <h5 className="fw-bold mb-3">
              {editId ? "Edit Payroll Item" : "Add Payroll Item"}
            </h5>

            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label fw-semibold">Name</label>
                <input
                  name="name"
                  className="form-control"
                  value={form.name}
                  onChange={handleChange}
                  placeholder="Basic, HRA, PF etc."
                />
              </div>

              {/* <div className="col-md-6">
                <label className="form-label fw-semibold">Code</label>
                <input
                  name="code"
                  className="form-control"
                  value={form.code}
                  onChange={handleChange}
                  placeholder="BASIC, HRA, PF etc."
                />
              </div> */}

              <div className="col-md-4">
                <label className="form-label fw-semibold">Type</label>
                <select
                  name="type"
                  className="form-select"
                  value={form.type}
                  onChange={handleChange}
                >
                  <option value="earning">Earning</option>
                  <option value="deduction">Deduction</option>
                  <option value="statutory">Statutory</option>
                </select>
              </div>

              <div className="col-md-4">
                <label className="form-label fw-semibold">Value Type</label>
                <select
                  name="value_type"
                  className="form-select"
                  value={form.value_type}
                  onChange={handleChange}
                >
                  <option value="fixed">Fixed</option>
                  <option value="percent">Percentage</option>
                </select>
              </div>

              {form.type === "statutory" && (
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    Statutory Code
                  </label>
                  <input
                    name="statutory_code"
                    className="form-control"
                    value={form.statutory_code}
                    onChange={handleChange}
                    placeholder="PF/12345 etc."
                  />
                </div>
              )}

              <div className="col-md-3">
                <label className="form-label fw-semibold d-block">
                  Taxable?
                </label>
                <input
                  type="checkbox"
                  name="is_taxable"
                  checked={form.is_taxable}
                  onChange={handleChange}
                />{" "}
                Yes
              </div>

              {/* <div className="col-md-3">
                <label className="form-label fw-semibold d-block">
                  Active?
                </label>
                <input
                  type="checkbox"
                  name="is_active"
                  checked={form.is_active}
                  onChange={handleChange}
                />{" "}
                Enabled
              </div> */}
            </div>

            {/* ACTION BUTTONS */}
            <div className="d-flex justify-content-end gap-2 mt-4">
              <button className="btn btn-secondary" onClick={cancelForm}>
                Cancel
              </button>
              <button className="btn btn-primary" onClick={saveItem}>
                {editId ? "Update Item" : "Save Item"}
              </button>
            </div>
          </div>
        )}

        {/* TABLE */}
        <div className="bg-white border rounded shadow-sm p-4">
          <h5 className="fw-bold mb-4">Manage Payroll Items</h5>

          <div className="table-responsive">
            <table className="table align-middle">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Type</th>
                  <th>Taxable</th>
                  <th>Statutory Code</th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                {items.map((i) => (
                  <tr key={i.id}>
                    <td>{i.name}</td>
                    <td>
                      <TypeBadge type={i.type} />
                    </td>
                    <td>{i.is_taxable ? "Yes" : "No"}</td>
                    <td>{i.statutory_code || "N/A"}</td>

                    <td>
                      <div className="dropdown">
                        <i
                          className="bi bi-three-dots-vertical"
                          data-bs-toggle="dropdown"
                          role="button"
                        ></i>

                        <ul className="dropdown-menu">
                          <li>
                            <button
                              className="dropdown-item"
                              onClick={() => startEdit(i)}
                            >
                              Edit
                            </button>
                          </li>

                          <li>
                            <button className="dropdown-item text-danger">
                              Delete
                            </button>
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ===========================
   TYPE BADGE
============================ */
function TypeBadge({ type }) {
  if (type === "earning")
    return (
      <span className="badge rounded-pill bg-success-subtle text-success px-3 py-2">
        Earning
      </span>
    );

  return (
    <span className="badge rounded-pill bg-danger-subtle text-danger px-3 py-2">
      Deduction
    </span>
  );
}
